import { createAction, props } from '@ngrx/store'
import { FlightNetworkCenterState, CenterStatus } from '../reducers/flight-network.reducer'
import { RPCChecklists } from 'src/app/common/jrpc.service'

export const loadCenter = createAction('[Center] Load Center')
export const loadCenterSuccess = createAction(
  '[Center] Load Center Success',
  props<{ center: FlightNetworkCenterState }>(),
)
export const loadCenterFailure = createAction('[Center] Load Center Failure', props<{ error: any }>())

export const setCenter = createAction('[Center] Set Center', props<{ center: FlightNetworkCenterState }>())
export const setCenterSuccess = createAction(
  '[Center] Set Center Success',
  props<{ center: FlightNetworkCenterState }>(),
)

export const initOpenStateChange = createAction(
  '[Center] Init Open State Change',
  props<{ center: FlightNetworkCenterState; status: CenterStatus; requiredChecklists: RPCChecklists }>(),
)
export const initOpenStateChangeSuccess = createAction('[Center] Init Open State Change Success')
export const initOpenStateChangeFailure = createAction(
  '[Center] Init Open State Change Failure',
  props<{ error: any }>(),
)

export const changeOpenState = createAction(
  '[Center] Change Open State',
  props<{ open_state: CenterStatus; center_id: number }>(),
)
export const changeOpenStateSuccess = createAction(
  '[Center] Change Open State Success',
  props<{ open_state: CenterStatus; center: FlightNetworkCenterState }>(),
)
export const changeOpenStateFailure = createAction('[Center] Change Open State Failure', props<{ error: any }>())

export const setCenterIdInLocalStorage = createAction('[Center] Center ID In LocalStorage', props<{ id: number }>())
